/*
 * Get-regions.ts
 * Description: Includes function for sending a request
 * to get all regions from the API
 */

// Importing Axios for HTTP requests
import Axios from 'axios';
// Importing required global variables
import {APIURL} from '@/ts/variables';

/**
 * Getting a list of all regions
 *
 * @return {Object} Promise - a list of all regions
 */
export function getRegions() {
    // Using promise to handle the async properties of JavaScript
    return new Promise((resolve, reject) => {
        Axios({
            url: APIURL + 'provinces',
            method: 'get',
        }).then((response) => {
            const provinces = [];
            // Creating a list suitable to be displayed in a select list
            for (const province of response.data.data) {
                provinces.push({
                    value: province.id,
                    text: province.attributes.name,
                });
            }
            resolve(provinces);
        }).catch(() => {
            reject();
        });
    });
}
